import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faImage, faExclamation, faSync, faMoneyBill, faSearch, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { ReactComponent as PhoneIcon } from "../../../images/phone.svg";

// Function to get creative icons for customer service issue types
export const getIssueTypeIcon = (issueType: string) => {
  const type = issueType.toUpperCase();
  if (type.includes('TRACKING ON TIME')) return <FontAwesomeIcon icon={faClock} />;
  if (type.includes('TRACKING LATE')) return <FontAwesomeIcon icon={faExclamation} />;
  if (type.includes('SENT IMAGED POD') || type.includes('POD')) return <FontAwesomeIcon icon={faImage} />;
  if (type.includes('RECONSIGNMENT')) return <FontAwesomeIcon icon={faSync} />;
  if (type.includes('OS&D') || type.includes('CLAIM')) return <FontAwesomeIcon icon={faExclamationTriangle} />;
  if (type.includes('BILLING')) return <FontAwesomeIcon icon={faMoneyBill} />;
  if (type.includes('TRACKING')) return <FontAwesomeIcon icon={faSearch} />;
  return <PhoneIcon />; // Default fallback
};

// Function to get colors for different issue types
export const getIssueTypeColor = (issueType: string, isTopIssue: boolean) => {
  if (isTopIssue) return "#2F80ED";
  
  const type = issueType.toUpperCase();
  if (type.includes('TRACKING ON TIME')) return "#27AE60"; // Green for on-time
  if (type.includes('TRACKING LATE')) return "#E74C3C"; // Red for late
  if (type.includes('SENT IMAGED POD')) return "#9B59B6"; // Purple for POD
  if (type.includes('RECONSIGNMENT')) return "#F39C12"; // Orange for reconsignment
  if (type.includes('OS&D') || type.includes('CLAIM')) return "#E67E22"; // Dark orange for claims
  if (type.includes('BILLING')) return "#16A085"; // Teal for billing
  return "#6c757d"; // Default gray
};

export const formatLabelSentenceCase = (label: string): string => {
  if (!label) return "";

  const abbreviations = ["ETA", "POD", "OS&D", "S/C"];

  // Split the label by space or slash but keep the separators
  const parts = label.split(/(\s|\/)/);

  let firstWordCapitalized = false;

  const formatted = parts.map(word => {
    // Preserve spaces or slashes
    if (word === " " || word === "/") return word;

    // Preserve abbreviation if it matches (case-insensitive)
    if (abbreviations.includes(word.toUpperCase())) {
      return word.toUpperCase();
    }

    // Capitalize only the first word of the string
    if (!firstWordCapitalized) {
      firstWordCapitalized = true;
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }

    // All other words lowercase
    return word.toLowerCase();
  });

  return formatted.join("");
};